export default "__VITE_ASSET__BhVTAv3C__"